import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import {
  AvailableOrganization,
  CounterpartyAccountByIdentityId,
} from '@/features/counterpartyAccounts/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const counterpartyAccountsApi = createApi({
  reducerPath: 'counterpartyAccountsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/counterparty-accounts',
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getCounterpartyAccountByIdentityId: builder.query<
      CounterpartyAccountByIdentityId,
      string
    >({
      query: identityId => ({
        url: `/by-identity-id`,
        params: { identityId },
      }),
    }),
    getAvailableOrganizations: builder.query<AvailableOrganization[], string>({
      query: id => ({
        url: `/${id}/available-organizations`,
      }),
    }),
  }),
});

export const { useGetAvailableOrganizationsQuery } = counterpartyAccountsApi;

export const { useGetCounterpartyAccountByIdentityIdQuery } =
  counterpartyAccountsApi;
